import Head from 'next/head';

export const PageTitle = ({ title }: { title: string }) => {
  return (
    <Head>
      <title key="title">{title}</title>
    </Head>
  );
};
